import { init } from '@invisible/sentry/client'
init()
